module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-TextItalic.88e5a2fc.otf";